import React from 'react';
import './Projects.css';
import { useNavigate } from 'react-router-dom';

import p2 from './p1.jpg';
import p3 from './p2.jpg';
import p4 from './p3.jpg';
import p5 from './p4.jpg';
import p6 from './p5.jpg';
import p7 from './p6.jpg';
import p8 from './p7.jpg';
import p9 from './p8.jpg';

const projects = [
  {
    title: 'Side Gate Project — Binbrook',
    info: 'A durable, well-finished side gate for a residential property in Binbrook. Pressure-treated lumber with rust-resistant hardware — strong, smooth-swinging, and seamlessly matching the fence line.',
    photo: p2,
  },
  {
    title: 'Full Privacy Overlap Fence — East Mountain',
    info: 'A five-panel privacy fence that filled a gap and created a fully enclosed backyard. Weather-resistant wood and reinforced posts give a clean, secure result from every angle.',
    photo: p3,
  },
  {
    title: 'Elevated Back Deck — Ancaster',
    info: 'A raised deck over a sloped yard — designed for gatherings and daily use. Built with safety railings, stair access, and long-lasting materials to handle every season.',
    photo: p4,
  },
  {
    title: 'Full Fence Replacement',
    info: 'Complete teardown and rebuild of a rotted, leaning fence. New concrete footings, re-leveled line, and fresh materials — looks great and will hold for years.',
    photo: p5,
  },
  {
    title: 'Custom Sliding Gate',
    info: 'Engineered for vehicle access without sacrificing security or curb appeal. Horizontal track system with smooth-glide rollers, matching the adjacent fencing with a modern finish.',
    photo: p6,
  },
  {
    title: 'Horizontal Board Fence — Ancaster',
    info: 'A full perimeter fence using horizontal boards for maximum privacy and a clean contemporary look. Every cut and corner measured to exact spec for a flawless finish.',
    photo: p7,
  },
  {
    title: 'Wrought Iron Gate and Fence — Hamilton Escarpment',
    info: 'Black powder-coated metal fencing anchored in rocky terrain near the escarpment. Preserves the view, defines the space, and adds lasting elegance to the property.',
    photo: p8,
  },
  {
    title: 'Ground-Level Back Deck — Stoney Creek',
    info: 'A casual outdoor area for relaxing and entertaining. Pressure-treated lumber with a smooth sanded finish, designed to work with the yard layout and hold up for years.',
    photo: p9,
  },
];

const Projects = () => {
  const navigate = useNavigate();

  return (
    <div className="projects-page">

      <div className="projects-hero">
        <h1>Our Recent Work</h1>
        <p>From small repairs to full builds — a look at some of the jobs we've completed across Hamilton and beyond.</p>
      </div>

      <div className="projects-body">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <div className="project-card-img">
              <img src={project.photo} alt={project.title} />
            </div>
            <div className="project-card-text">
              <h2>{project.title}</h2>
              <p>{project.info}</p>
            </div>
          </div>
        ))}

        <div className="projects-footer-cta">
          <h2>Have a Project in Mind?</h2>
          <p>Reach out to Aaron for a free, no-obligation estimate. We're ready to help.</p>
          <button className="btn-gold" onClick={() => navigate('/contact')}>Get a Free Estimate</button>
        </div>
      </div>

    </div>
  );
};

export default Projects;
